const license = {
    not_installed: 'Nenhuma licença está instalada nesta instância.',
    invalid_key: 'A chave de licença é inválida ou foi adulterada.',
    expired_key: 'A chave de licença expirou. Obtenha uma nova chave e instale-a novamente.',
};
export default Object.freeze(license);
